import { NetArea, UserSettingsTO } from '../../api/generated/v2/incident';

export class SystemUserSettings implements UserSettingsTO {
  constructor(
    public emailFavorites?: string[],
    public netArea?: NetArea,
    ) { }
}
